







import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import i18n from "@/i18n";

@Component({
	components: {},
})
export default class PayBackTip extends Vue {
	payTitle: string = i18n.t("common.tips") as string;
	myVisiable: boolean = false;

	@Prop({ type: Boolean, default: false })
	payVisiable;

	@Prop({
		type: String,
		default() {
			return i18n.t("common.pay_back_tip");
		},
	})
	payMessage;

	@Watch("payVisiable")
	handleShow(val, oldVal) {
		if (val && val !== oldVal) {
			this.myVisiable = val;
		}
	}

	handleConfirm() {
		this.$emit("update:payVisiable", false);
		this.$emit("handleConfirm");
	}

	handleCancel() {
		this.$emit("update:payVisiable", false);
		this.$emit("handleCancel");
	}
}
